export default "__VITE_ASSET__DvhiE4A8__"